import { Grid } from '@material-ui/core';
import React from 'react';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import Carousel from 'react-elastic-carousel';
import { v4 as uuidv4 } from 'uuid';

import {
  AimsFile,
  DeficiencyFileEdited,
  GroupedBasedOnShowOnReport,
  GroupedBasedOnShowOnReportForUploading,
} from '../../models/models';
import type { DeficiencyFilesDocument } from '../../rxdb/deficiencyFiles/deficiencyFiles.types';
import Thumbnail from '../Thumbnails';
import UnSavedFiles from '../UnSavedFiles';
import useStyles from './DeficiencyFilesView.styles';

interface Props {
  showOnReportImages: GroupedBasedOnShowOnReport;
  showOnReportImages1: GroupedBasedOnShowOnReportForUploading;
  fileList: (DeficiencyFileEdited | DeficiencyFilesDocument)[];
  filesToUpload: AimsFile[];
  updateFileList: (updatedFileList: DeficiencyFileEdited[]) => void;
  updateUploadFileList: (updatedFileList: AimsFile[]) => void;
  isEditable: boolean;
  showInfoMessage: (value: boolean) => void;
  isActiveDeficiency: boolean;
}

const DeficiencyFilesView: React.FC<Props> = ({
  showOnReportImages,
  showOnReportImages1,
  fileList,
  filesToUpload,
  updateFileList,
  updateUploadFileList,
  isEditable,
  showInfoMessage,
  isActiveDeficiency,
}) => {
  const classes = useStyles();
  const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 550, itemsToShow: 2 },
    { width: 768, itemsToShow: 3 },
  ];
  const checkShowOnReport = () => {
    let countOfShowOnReportFiles = 0;
    if (showOnReportImages1?.true?.length) {
      countOfShowOnReportFiles += showOnReportImages1?.true.length;
    }
    if (showOnReportImages?.true?.length) {
      countOfShowOnReportFiles += showOnReportImages?.true.length;
    }
    return countOfShowOnReportFiles >= 5;
  };

  const getFileOrder = (list: DeficiencyFileEdited[]) => {
    const fileOrder = list[list.length - 1]?.fileSortOrder;
    if (fileOrder !== undefined) {
      return fileOrder + 1;
    } else {
      return list.length;
    }
  };

  return (
    <div className={classes.difImageContainer}>
      <Droppable droppableId="false" direction="horizontal">
        {provided => (
          <div ref={provided.innerRef} {...provided.droppableProps}>
            <div className={classes.droppleContainer}>
              <p>Not Show on Report</p>

              {showOnReportImages?.false?.length > 0 || showOnReportImages1?.false?.length > 0 ? (
                <Carousel
                  itemsToScroll={2}
                  pagination={false}
                  isRTL={false}
                  breakPoints={breakPoints}
                  preventDefaultTouchmoveEvent={false}
                  enableSwipe={false}
                  enableMouseSwipe={false}
                  enableAutoPlay={false}
                >
                  {showOnReportImages?.false
                    ?.sort((a, b) => {
                      if (a.fileSortOrder !== undefined && b.fileSortOrder !== undefined) {
                        return a.fileSortOrder - b.fileSortOrder;
                      } else {
                        return 0;
                      }
                    })
                    ?.map((data: DeficiencyFileEdited, index: number) => {
                      return (
                        <Draggable
                          key={data.fileAimsUUID}
                          draggableId={`${data.fileAimsUUID}^false`}
                          index={index}
                        >
                          {providedData => (
                            <Grid
                              className={classes.notShowonReportContainer}
                              ref={providedData.innerRef}
                              {...providedData.draggableProps}
                              {...providedData.dragHandleProps}
                            >
                              <Grid>
                                <Thumbnail
                                  fileData={data}
                                  fileList={fileList}
                                  index={fileList.findIndex(
                                    value => value.fileAimsUUID === data.fileAimsUUID,
                                  )}
                                  isShowOnReport={checkShowOnReport()}
                                  updateFileList={updateFileList}
                                  arrayListLength={getFileOrder(showOnReportImages.false)}
                                  setDragDisable={() => {}}
                                  isEditable={isEditable}
                                  showInfoMessage={showInfoMessage}
                                  isActiveDeficiency={isActiveDeficiency}
                                />
                              </Grid>
                            </Grid>
                          )}
                        </Draggable>
                      );
                    })}
                  {showOnReportImages1?.false
                    ?.sort((a, b) => {
                      if (a.fileSortOrder !== undefined && b.fileSortOrder !== undefined) {
                        return a.fileSortOrder - b.fileSortOrder;
                      } else {
                        return 0;
                      }
                    })
                    ?.map((data: AimsFile, index: number) => {
                      return (
                        <Draggable
                          key={`${data.updatedName}-${data.lastModified}`}
                          draggableId={`${data.updatedName}-${data.lastModified}^false`}
                          index={index}
                        >
                          {providedData => (
                            <Grid
                              className={classes.notShowonReportContainer}
                              ref={providedData.innerRef}
                              {...providedData.draggableProps}
                              {...providedData.dragHandleProps}
                            >
                              <Grid>
                                <UnSavedFiles
                                  fileData={data}
                                  fileList={filesToUpload}
                                  index={filesToUpload.findIndex(
                                    (item: AimsFile) => item.updatedName === data.updatedName,
                                  )}
                                  uniqueId={`editDeficiency-imageToUpload-${
                                    (data.updatedName, uuidv4())
                                  }`}
                                  isShowOnReport={checkShowOnReport()}
                                  updateFileList={updateUploadFileList}
                                  isEditable={isEditable}
                                />
                              </Grid>
                            </Grid>
                          )}
                        </Draggable>
                      );
                    })}
                  {provided.placeholder}
                </Carousel>
              ) : null}
            </div>
          </div>
        )}
      </Droppable>
      <Droppable droppableId="true" direction="horizontal">
        {provided => (
          <div ref={provided.innerRef} {...provided.droppableProps}>
            <div className={classes.droppleContainer}>
              <p>Show On Report</p>
              {showOnReportImages?.true?.length > 0 || showOnReportImages1?.true?.length > 0 ? (
                <Carousel
                  itemsToScroll={2}
                  pagination={false}
                  isRTL={false}
                  breakPoints={breakPoints}
                  preventDefaultTouchmoveEvent={false}
                  enableSwipe={false}
                  enableMouseSwipe={false}
                  enableAutoPlay={false}
                >
                  {showOnReportImages?.true
                    ?.sort((a, b) => {
                      if (a.fileSortOrder !== undefined && b.fileSortOrder !== undefined) {
                        return a.fileSortOrder - b.fileSortOrder;
                      } else {
                        return 0;
                      }
                    })
                    ?.map((data: DeficiencyFileEdited, index: number) => {
                      return (
                        <Draggable
                          key={data.fileAimsUUID}
                          draggableId={`${data.fileAimsUUID}^true`}
                          index={index}
                        >
                          {providedData => (
                            <Grid
                              draggable="false"
                              className={classes.notShowonReportContainer}
                              ref={providedData.innerRef}
                              {...providedData.draggableProps}
                              {...providedData.dragHandleProps}
                            >
                              <Grid draggable="false">
                                <Thumbnail
                                  fileData={data}
                                  fileList={fileList}
                                  index={fileList.findIndex(
                                    value => value.fileAimsUUID === data.fileAimsUUID,
                                  )}
                                  isShowOnReport={checkShowOnReport()}
                                  updateFileList={updateFileList}
                                  arrayListLength={getFileOrder(showOnReportImages.false || [])}
                                  setDragDisable={() => {}}
                                  isEditable={isEditable}
                                  showInfoMessage={showInfoMessage}
                                  isActiveDeficiency={isActiveDeficiency}
                                />
                              </Grid>
                            </Grid>
                          )}
                        </Draggable>
                      );
                    })}
                  {showOnReportImages1?.true
                    ?.sort((a, b) => {
                      if (a.fileSortOrder !== undefined && b.fileSortOrder !== undefined) {
                        return a.fileSortOrder - b.fileSortOrder;
                      } else {
                        return 0;
                      }
                    })
                    ?.map((data: AimsFile, index: number) => {
                      return (
                        <Draggable
                          key={`${data.updatedName}-${data.lastModified}`}
                          draggableId={`${data.updatedName}-${data.lastModified}^true`}
                          index={index}
                        >
                          {providedData => (
                            <Grid
                              className={classes.notShowonReportContainer}
                              ref={providedData.innerRef}
                              {...providedData.draggableProps}
                              {...providedData.dragHandleProps}
                            >
                              <Grid>
                                <UnSavedFiles
                                  fileData={data}
                                  fileList={filesToUpload}
                                  index={filesToUpload.findIndex(
                                    (item: AimsFile) => item.updatedName === data.updatedName,
                                  )}
                                  uniqueId={`editDeficiency-imageToUpload-${
                                    (data.updatedName, uuidv4())
                                  }`}
                                  isShowOnReport={checkShowOnReport()}
                                  updateFileList={updateUploadFileList}
                                  isEditable={isEditable}
                                />
                              </Grid>
                            </Grid>
                          )}
                        </Draggable>
                      );
                    })}
                  {provided.placeholder}
                </Carousel>
              ) : null}
            </div>
          </div>
        )}
      </Droppable>
    </div>
  );
};
export default DeficiencyFilesView;
